import { useCallback } from "react";

import { quoteCsvField } from "./csv-field";

import type { CsvFileNamePrefixKey, CsvHeadersType } from "./constants";

type CsvRow = string;

export const useCsv = () => {
	/**
	 *
	 * @description CSVファイルを生成
	 *
	 * @param headers {Array<CsvHeader>}
	 * @param rows {Array<CsvRow>}
	 *
	 * @returns {Blob}
	 *
	 */
	const csvGenerate = useCallback((headers: CsvHeadersType, rows: Array<CsvRow>): Blob => {
		const header = `\ufeff${headers.map(quoteCsvField).join(",")}`;
		const row = rows.join("\n");
		const csv = [header, row].join("\n");
		return new Blob([csv], { type: "text/csv" });
	}, []);

	/**
	 *
	 * @description CSVファイルをダウンロード
	 *
	 * @param blob {Blob}
	 * @param fileNamePrefix {string} - ex: CHILLNN_予約情報
	 *
	 * @returns {void}
	 *
	 */
	const csvDownload = useCallback((fileNamePrefix: CsvFileNamePrefixKey, blob: Blob): void => {
		const url = URL.createObjectURL(blob);
		const anchor = document.createElement("a");
		anchor.href = url;
		anchor.download = `${fileNamePrefix}_${new Date().getTime()}.csv`;
		anchor.click();
		URL.revokeObjectURL(url);
	}, []);

	return {
		csvGenerate,
		csvDownload,
	};
};
